import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PgUsuarioExistente = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { cpf, email, possuiSenha } = location.state || {};

    const abrirWhatsApp = () => {
        const mensagem = encodeURIComponent('Olá, já possuo cadastro mas estou com dificuldades para acessar.');
        window.open(`https://wa.me/5521979621222?text=${mensagem}`, '_blank');
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow">
                        <div className="card-header bg-warning text-dark">
                            <h4 className="mb-0">⚠️ Cadastro Já Existe</h4>
                        </div>
                        <div className="card-body">
                            <div className="alert alert-warning">
                                <strong>Atenção!</strong> Já existe um cadastro com os dados informados.
                            </div>

                            {possuiSenha ? (
                                <div>
                                    <h5 className="mb-3">✅ Você já possui cadastro completo</h5>
                                    <p className="mb-4">
                                        Seus dados já estão registrados no sistema e você possui uma senha cadastrada.
                                        Para acessar o portal, utilize a opção de login.
                                    </p>
                                    
                                    <div className="d-grid gap-2 mb-4">
                                        <button
                                            className="btn btn-primary btn-lg"
                                            onClick={() => navigate('/login')}
                                        >
                                            🔐 Fazer Login
                                        </button>
                                    </div>

                                    <hr />

                                    <div className="text-center">
                                        <p className="text-muted mb-3">
                                            <strong>Esqueceu sua senha ou precisa de ajuda?</strong>
                                        </p>
                                        <button
                                            className="btn btn-success btn-lg"
                                            onClick={abrirWhatsApp}
                                        >
                                            <i className="fab fa-whatsapp me-2"></i>
                                            Falar no WhatsApp
                                        </button>
                                        <p className="text-muted mt-2 mb-0">
                                            <small>(21) 97962-1222</small>
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <h5 className="mb-3">🔑 Senha Pendente</h5>
                                    <p className="mb-4">
                                        Seus dados já estão cadastrados, mas você ainda não possui uma senha registrada.
                                        Entre em contato conosco pelo WhatsApp para que possamos enviar o link de cadastro de senha.
                                    </p>

                                    <div className="d-grid gap-2 mb-4">
                                        <button
                                            className="btn btn-success btn-lg"
                                            onClick={abrirWhatsApp}
                                        >
                                            <i className="fab fa-whatsapp me-2"></i>
                                            Falar no WhatsApp
                                        </button>
                                        <p className="text-center text-muted mt-2 mb-0">
                                            <small>(21) 97962-1222</small>
                                        </p>
                                    </div>

                                    <div className="alert alert-info mt-3">
                                        <strong>ℹ️ O que você precisa fazer:</strong>
                                        <ol className="mb-0 mt-2">
                                            <li>Clique no botão acima para abrir o WhatsApp</li>
                                            <li>Informe que precisa do link de cadastro de senha</li>
                                            <li>Você receberá um email com o link para criar sua senha</li>
                                            <li>Após criar a senha, faça login normalmente</li>
                                        </ol>
                                    </div>
                                </div>
                            )}

                            <div className="mt-4 text-center">
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={() => navigate('/')}
                                >
                                    ← Voltar para o Início
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PgUsuarioExistente;
